/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export enum DomainCorpTransactionSourceString {
    "CorpTransactionSourceStringPayment" = "payment",
    "CorpTransactionSourceStringCharge" = "charge",
    "CorpTransactionSourceStringBonus" = "bonus",
    "CorpTransactionSourceStringIncome" = "income",
    "CorpTransactionSourceStringOrderRefund" = "order_refund",
    "CorpTransactionSourceStringMoneyRefund" = "money_refund",
    "CorpTransactionSourceStringCorpBalanceTransfer" = "corp_balance_transfer"
}